<template>
  <div>
    <div class="card mb-3" v-if="user !== null">
      <div class="card-body" v-if="success === null || success === false">
        <div class="form-group">
          <label for="current">현재 비밀번호</label>
          <input type="password" class="form-control" id="current" placeholder=""
                 v-model.trim="current"
                 name="current"
                 v-validate="'required|min:8'"
                 :class="{'is-invalid': errors.has('current')}">
          <div class="invalid-feedback" v-if="errors.has('current')">
            비밀번호를 입력하세요. ( 8자 이상 )
          </div>
        </div>
        <div class="form-group">
          <label for="password1">새 비밀번호</label>
          <input type="password" class="form-control" id="password1" placeholder=""
                 v-model.trim="password1"
                 name="password1"
                 v-validate="'required|min:8'"
                 :class="{'is-invalid': errors.has('password1')}"
                 ref="password1">
          <div class="invalid-feedback" v-if="errors.has('password1')">
            새 비밀번호를 입력하세요. ( 8자 이상 )
          </div>
        </div>

        <div class="form-group">
          <label for="password2">새 비밀번호 확인</label>
          <input type="password" class="form-control" id="password2" placeholder=""
                 v-model.trim="password2"
                 name="password2"
                 v-validate="'required|min:8|confirmed:password1'"
                 :class="{'is-invalid': errors.has('password2')}"
                 ref="password2">
          <div class="invalid-feedback" v-if="errors.has('password2')">
            <template v-if="errors.firstRule('password2') === 'required'">
              새 비밀번호를 한번 더 입력하세요. ( 8자 이상 )
            </template>
            <template v-else-if="errors.firstRule('password2') === 'confirmed'">
              새 비밀번호가 일치하지 않습니다.
            </template>
          </div>
        </div>

        <div class="text-center">
          <button type="button" class="btn btn-outline-secondary" @click="update">변경</button>
        </div>
      </div>
      <div class="card-body" v-else>
        <p>비밀번호가 변경되었습니다.</p>

        <div class="text-center">
          <button type="button" class="btn btn-outline-secondary" @click="reset">확인</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AdminUser',
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      current: '',
      password1: '',
      password2: '',
      success: null,
    };
  },
  mounted() {

  },
  methods: {
    reset() {
      this.current = '';
      this.password1 = '';
      this.password2 = '';
      this.success = null;
    },
    async update() {
      await this.$validator.validateAll();

      if (this.errors.any()) return;

      this.$axios.post('/admin/user/password', {
        current: this.current,
        password1: this.password1,
        password2: this.password2,
      }).then(
        () => {
          this.success = true;
        },
        () => {
          this.success = false;
        },
      );
    },
  },
};
</script>

<style scoped>

</style>
